<template>
    <!-- <div class="header">
        <div class="inner-header">
            <div class="Logo-container">
                <h2>Knerten Familiebarnehage</h2>
            </div>
        

            <ul class="nav">
                <router-link to="/"><li>Hjem</li></router-link>
                <router-link to="/aktiviteter"><li>Aktiviteter</li></router-link>
                <router-link to="/søke-barnehageplass"><li>Søke barnehageplass</li></router-link>
                <router-link to="/om-oss"><li>Om oss</li></router-link>
                <router-link to="/kontakt-oss"><li>Kontakt oss</li></router-link>
            </ul>
        </div>
    </div> -->

    <div class="out-header">

    
    <div class="inner-header">
  

  <b-navbar class="header" toggleable="lg" type="dark">
    <b-navbar-brand v-on:click="tab = 1" href="#/">Knerten Familiebarnehage</b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
        <b-nav-item v-bind:active="tab === 1" v-on:click="tab = 1" href="#/">Hjem</b-nav-item>
        <b-nav-item v-bind:active="tab === 2" v-on:click="tab = 2" href="#/aktiviteter">Aktiviteter</b-nav-item>
        <b-nav-item v-bind:active="tab === 3" v-on:click="tab = 3" href="#/om-oss">Om oss</b-nav-item>
        <b-nav-item v-bind:active="tab === 4" v-on:click="tab = 4" href="#/søke-barnehageplass">Søke barnehageplass</b-nav-item>
        <b-nav-item v-bind:active="tab === 5" v-on:click="tab = 5" href="#/kontakt-oss">Kontakt oss</b-nav-item>
        <!-- <b-nav-item v-bind:active="tab === 6" v-on:click="tab = 6" href="#/aktiviteterBilde">Aktiviteter Bilde</b-nav-item> -->
        

        <!-- Navbar dropdowns -->
        <!-- <b-nav-item-dropdown text="Lang" right>
            <b-dropdown-item href="#">EN</b-dropdown-item>
            <b-dropdown-item href="#">ES</b-dropdown-item>
            <b-dropdown-item href="#">RU</b-dropdown-item>
            <b-dropdown-item href="#">FA</b-dropdown-item>
        </b-nav-item-dropdown> -->

        <!-- <b-nav-item-dropdown text="User" right>
            <b-dropdown-item href="#">Account</b-dropdown-item>
            <b-dropdown-item href="#">Settings</b-dropdown-item>
        </b-nav-item-dropdown> -->
        </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</div>
</div>
</template>


<script>

export default {
    name: "Header",
    data() {
        return {
            tab: 1,
            refresh:'',
        }
    },
    mounted() {
        this.refresh = this.$route.name
    },
}
</script>

<style scoped>

.header {
background-color: #667CB0;
}

@media screen and (min-width: 1001px) {
.inner-header {
    width: 70%;
    height: 100%;
    /* display: block; */
    margin: 0 auto;
}
.out-header {
    width: 100%;
    height: 75px;
    background-color: #667CB0;
}
}

/* .Logo-container {
    height: 100%;
    display: table;
    float: left;
} */
/* .Logo-container h2{
    color: white;
    height: 100%;
    display: table-cell;
    vertical-align: middle;
} */
/* .nav {
    margin-top: 0;
    float: right;
    height: 100%;
}
.nav a {
    height: 100%;
    display: table;
    float: left;
    padding: 0px 10px;
    text-decoration: none;
}
.nav a li {
    display: table-cell;
    vertical-align: middle;
    height: 100%;
    color: white;

}
.nav a:last-child {
    padding-right: 0px;
} */
</style>

